import Log from 'providers/log';
import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';

const getDefaultStyles = (props: Props): any => {
    const retPart: any = {
        overflow: 'auto'
    };
    if (props.direction === 'both') {
        return {
            ...retPart,
            maxHeight: 0,
            maxWidth: 0,
            transition: 'max-height 500ms ease, max-width 500ms ease'
        };
    }
    if (props.direction === 'vertical') {
        return {
            ...retPart,
            maxHeight: 0,
            transition: 'max-height 500ms ease'
        };
    }
    if (props.direction === 'horizontal') {
        return {
            ...retPart,
            maxWidth: 0,
            transition: 'max-width 500ms ease'
        };
    }
    return {};
};

const getTransitionStyles = (props: Props): any => {
    let entering = {};
    let entered = {};
    switch (props.direction) {
        case 'horizontal':
            if (!props.maxWidth) {
                Log.error('Width prop is required for "horizontal" direction', 'Expandable');
                return;
            }
            break;
        case 'vertical':
            if (!props.maxHeight) {
                Log.error('Height prop is required for "vertical" direction', 'Expandable');
                return;
            }
            break;
        case 'both':
            if (!props.maxHeight || !props.maxWidth) {
                Log.error('Height and width props are required for "both" direction', 'Expandable');
                return;
            }
            break;
        default:
            Log.error(`Expandable direction "${props.direction}" is invalid`, 'Expandable');
            return;
    }

    if (props.direction === 'vertical' || props.direction === 'both') {
        entering = { ...entering, maxHeight: 0 };
        entered = { ...entered, maxHeight: props.maxHeight };
    }

    if (props.direction === 'horizontal' || props.direction === 'both') {
        entering = { ...entering, maxWidth: 0 };
        entered = { ...entered, maxWidth: props.maxWidth };
    }

    return { entering, entered };
};

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    expanded: boolean;
    /** Ensure this value is equal to or only slightly greater than the actual height of the children or the transition timing will be off */
    maxHeight?: string;
    /** Ensure this value is equal to or only slightly greater than the actual width of the children or the transition timing will be off */
    maxWidth?: string;
    direction: string;
}

/** Wraps children in component that is completely hidden until expanded is true at which point it will transition open in the specified direction. Once expanded is false again, it will transition closed and become hidden again */
const Expandable: React.StatelessComponent<Props> = (props: Props) => {
    const transitionStylesToUse = getTransitionStyles(props);
    if (!transitionStylesToUse) return null; // error logging happens in getTransitionStyles
    return(
        <TransitionGroup>
            {props.expanded && <Transition timeout={{ enter:0, exit:500 }}>
                {(state: string) => <div className={props.className} style={{ ...getDefaultStyles(props), ...getTransitionStyles(props)[state] }}>
                {props.children}
                </div>}
            </Transition>}
        </TransitionGroup>
    );
};

export default Expandable;



// WEBPACK FOOTER //
// ./src/components/global/application/Expandable.tsx